import { runpod_permission } from "./runpod.permission";

export const readiness_permission= {
    required_permission:['view_competency','view_readiness', 'add_readiness', 'change_readiness', 'delete_readiness','add_readinesslevel','change_readinesslevel','delete_readinesslevel','view_readinesslevel'],
    competency_permission:['view_competency','add_competency', 'change_competency', 'delete_competency'],
    employee_permission:['view_employee', 'view_user'],
    runpod_permission:runpod_permission?.required_permission
}